import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component, isValidElement, cloneElement } from 'react';
import { selectClass } from './styles';
import { focusElement, getCursorOffset, preventPasteFile } from '../utils/dom/element';
import { isString } from '../utils/is';

var handleFocus = function handleFocus(e) {
  e.stopPropagation();
};

var DefaultValue = {
  text: '',
  updatAble: false
};

var FilterInput =
/*#__PURE__*/
function (_Component) {
  _inherits(FilterInput, _Component);

  var _super = _createSuper2(FilterInput);

  function FilterInput(props) {
    var _this;

    _classCallCheck(this, FilterInput);

    _this = _super.call(this, props);
    _this.lastCursorOffset = void 0;
    _this.composition = void 0;
    _this.editElement = void 0;
    _this.lastSelect = void 0;
    _this.lastMaxValue = void 0;
    _this.blurTimer = void 0;
    _this.state = {
      editable: false
    };
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    _this.handleInput = _this.handleInput.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.geHandleMax = _this.geHandleMax.bind(_assertThisInitialized(_this));
    _this.handlePaste = _this.handlePaste.bind(_assertThisInitialized(_this));
    _this.focusInput = _this.focusInput.bind(_assertThisInitialized(_this));
    _this.handleCompositionStart = _this.handleCompositionStart.bind(_assertThisInitialized(_this));
    _this.handleCompositionEnd = _this.handleCompositionEnd.bind(_assertThisInitialized(_this)); // for mutiple select

    _this.props.setInputReset(_this.reset.bind(_assertThisInitialized(_this))); // set focus func to Select


    props.bindFocusInputFunc(_this.focusInput);
    return _this;
  }

  _createClass(FilterInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.focus) {
        this.props.onInputFocus();
        this.focus();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return this.props.updatAble;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.focus === prevProps.focus || !this.props.focus) return;
      this.props.onInputFocus();
      this.focus();
    }
  }, {
    key: "getProcessedValue",
    value: function getProcessedValue(text) {
      var trim = this.props.trim;
      if (!trim && this.lastCursorOffset === 0 && /^\u00A0$/.test(text)) return '';
      return trim ? text.trim() : text.replace(/\u00A0/g, ' ');
    }
  }, {
    key: "handlePaste",
    value: function handlePaste(e) {
      var _this2 = this;

      var convertBr = this.props.convertBr;
      preventPasteFile(e, function (text) {
        if (window.getSelection) {
          var selection = window.getSelection();
          _this2.lastSelect = {
            anchorOffset: selection.anchorOffset,
            focusOffset: selection.focusOffset,
            text: text
          };
        }
      }, {
        convertBr: convertBr
      });
    }
  }, {
    key: "geHandleMax",
    value: function geHandleMax(e) {
      var maxLength = this.props.maxLength;

      if (!maxLength || this.composition) {
        return true;
      }

      var change = true;
      var text = e.target.innerText;

      if (text.length >= maxLength) {
        var lastPos; // 输入的位置 需要考虑选中文本的情况

        if (window.getSelection) {
          lastPos = Math.min(window.getSelection().anchorOffset - (text.length > maxLength ? 1 : 0), maxLength);
        }

        if (!this.lastMaxValue) {
          this.lastMaxValue = text.slice(0, maxLength); // 粘贴文本的情况
        } else if (this.lastSelect && typeof this.lastSelect !== 'boolean') {
          var _this$lastSelect = this.lastSelect,
              _anchorOffset = _this$lastSelect.anchorOffset,
              _focusOffset = _this$lastSelect.focusOffset,
              str = _this$lastSelect.text;
          var start = _anchorOffset < _focusOffset ? _anchorOffset : _focusOffset;
          var end = _anchorOffset > _focusOffset ? _anchorOffset : _focusOffset;

          if (end - start > 0) {
            this.lastMaxValue = this.lastMaxValue.slice(0, start) + str.slice(0, end - start) + this.lastMaxValue.slice(end);
            lastPos = _focusOffset;
          } else {
            change = false;
          }
        } else {
          change = false;
        } // clear select info


        this.lastSelect = false;
        e.target.innerText = this.lastMaxValue; // 修改e.target.innerText后光标会变到最前面，这儿改变光标位置到上次光标的位置

        if (lastPos) {
          var selection = window.getSelection();
          var range = selection.getRangeAt(0);
          var textNode = range.startContainer;

          if (textNode.nodeName !== '#text') {
            ;
            var _ref = textNode.childNodes;

            var _ref2 = _slicedToArray(_ref, 1);

            textNode = _ref2[0];
          }

          range.setStart(textNode, lastPos);
          range.collapse(true);
        }
      } else {
        this.lastMaxValue = '';
      } // eslint-disable-next-line consistent-return


      return change;
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.editElement) this.editElement.innerText = '';
      if (this.blurTimer) clearTimeout(this.blurTimer);
    }
  }, {
    key: "focusInput",
    value: function focusInput() {
      var _this3 = this;

      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!flag) {
        this.setState({
          editable: false
        });
        return;
      }

      this.setState({
        editable: true
      }, function () {
        return _this3.focus();
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this4 = this;

      var focusSelected = this.props.focusSelected;
      var action = focusSelected ? focusElement.select : focusElement.end;
      requestAnimationFrame(function () {
        action(_this4.editElement);
      });
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      this.editElement = el;
    }
  }, {
    key: "handleInput",
    value: function handleInput(e) {
      var onFilter = this.props.onFilter;
      var change = this.geHandleMax(e);

      if (!change) {
        return;
      }

      var text = e.target.innerText.replace('\feff ', '');
      this.lastCursorOffset = getCursorOffset(text.length);
      var t = this.getProcessedValue(text);
      if (onFilter) onFilter(t);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var txt = this.props.text;
      var text = this.getProcessedValue(e.target.innerText.replace('\feff ', ''));
      this.focusInput(false);
      if (text === txt) return;
      this.props.onInputBlur(text);
    }
  }, {
    key: "handleCompositionStart",
    value: function handleCompositionStart() {
      this.composition = true;
    }
  }, {
    key: "handleCompositionEnd",
    value: function handleCompositionEnd(e) {
      this.composition = false;
      this.handleInput(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          text = _this$props.text,
          focus = _this$props.focus,
          multiple = _this$props.multiple;
      var value = typeof text === 'string' ? text.replace(/<\/?[^>]*>/g, '') : text;
      var props = {
        className: selectClass('input', !focus && 'ellipsis', !multiple && 'full'),
        ref: this.bindElement,
        key: 'input',
        onInput: this.handleInput,
        contentEditable: focus || this.state.editable,
        onFocus: handleFocus,
        onBlur: this.handleBlur,
        title: !focus && isString(value) ? value : undefined,
        onCompositionStart: this.handleCompositionStart,
        onCompositionEnd: this.handleCompositionEnd
      };

      if (
      /*#__PURE__*/
      isValidElement(value)) {
        if (value.type.toString() === 'Symbol(react.fragment)') {
          return (
            /*#__PURE__*/
            cloneElement(
            /*#__PURE__*/
            React.createElement("span", null, value), _objectSpread2(_objectSpread2({}, props), {}, {
              suppressContentEditableWarning: true
            }))
          );
        }

        return (
          /*#__PURE__*/
          cloneElement(value, _objectSpread2(_objectSpread2({}, props), {}, {
            // @ts-ignore
            // cloneElement 中的默认类型 React.HTMLAttributes 缺失 suppressContentEditableWarning
            suppressContentEditableWarning: true
          }))
        );
      } // @ts-ignore


      return (
        /*#__PURE__*/
        React.createElement("span", Object.assign({
          dangerouslySetInnerHTML: {
            __html: value
          }
        }, props, {
          onPaste: this.handlePaste
        }))
      );
    }
  }]);

  return FilterInput;
}(Component);

FilterInput.defaultProps = DefaultValue;
export default FilterInput;